import axios from "axios";

export default axios.create({
  baseURL: "https://elate-leads-api.azurewebsites.net/api",
});
